import { c as _c } from "react/compiler-runtime";
import type { Project } from 'content-collections';
import { LightbulbIcon } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { ContentCard } from './content-card';
type ProjectCardProps = {
  project: Project;
  featured?: boolean;
  lazy?: boolean;
};
export function ProjectCard(props) {
  const $ = _c(19);
  const {
    project,
    featured: t0,
    lazy: t1
  } = props;
  const featured = t0 === undefined ? false : t0;
  const lazy = t1 === undefined ? true : t1;
  const t = useTranslations();
  const t2 = project.slug;
  const t3 = `/projects/${project.slug}`;
  let t4;
  if ($[0] !== t) {
    t4 = t("homepage.selected-projects.card");
    $[0] = t;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = `/images/projects/${project.slug}/cover.png`;
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <LightbulbIcon className="size-4.5" />;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  let t7;
  if ($[3] !== project.name) {
    t7 = <h3 className="text-2xl font-semibold">{project.name}</h3>;
    $[3] = project.name;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] !== project.description) {
    t8 = <p className="mt-2 text-muted-foreground">{project.description}</p>;
    $[5] = project.description;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== t7 || $[8] !== t8) {
    t9 = <div className="flex flex-col px-2 py-4 transition-transform ease-out group-hover:translate-x-0.5">{t7}{t8}</div>;
    $[7] = t7;
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== featured || $[11] !== lazy || $[12] !== project.description || $[13] !== project.slug || $[14] !== t3 || $[15] !== t4 || $[16] !== t5 || $[17] !== t9) {
    t10 = <ContentCard key={t2} href={t3} title={t4} image={t5} imageAlt={project.description} icon={t6} featured={featured} lazy={lazy}>{t9}</ContentCard>;
    $[10] = featured;
    $[11] = lazy;
    $[12] = project.description;
    $[13] = project.slug;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
}